export default {
  /**
   * 判断数组中是否包含某个值
   * 
   * @param {Array} arr 数组
   * @param {*} val 需要判断的值
   */
  includeArray(arr, val) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] == val) {
        return true;
      }
    }
    return false;
  },

  /**
   * 深拷贝
   * 
   * @param {*} data 需要拷贝的数据
   */
  deepClone(data) {
    var type = getType(data);
    var obj;
    if (type === 'array') {
      obj = [];
    } else if (type === 'object') {
      obj = {};
    } else {
      //不再具有下一层次
      return data;
    }
    if (type === 'array') {
      for (var i = 0, len = data.length; i < len; i++) {
        obj.push(this.deepClone(data[i]));
      }
    } else if (type === 'object') {
      for (var key in data) {
        obj[key] = this.deepClone(data[key]);
      }
    }
    return obj;
  },

  /**
   * 判断对象数组中的对象是否包含某个值
   * 
   * @param {Array} arr 需要判断的数组
   * @param {String} key 需要判断的Key
   * @param {*} val 判断的值
   */
  determineObjectForArray(arr, key,val) {
    for (const k in arr) {
      if (arr.hasOwnProperty(k)) {
        const element = arr[k];
        if (element[key] == val) {
          return true;
        }
      }
    }
    return false;
  },
}

function getType(obj) {
  //tostring会返回对应不同的标签的构造函数
  var toString = Object.prototype.toString;
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
}



// WEBPACK FOOTER //
// ./src/fetch/tool.js